export const nativeAppSwaUserAgentTokens = ["SWAIOSWebview", "SWAAndroidWebview"];
